declare global {
  interface Window {
    __APP_CONFIG__?: {
      API_BASE_URL?: string;
    };
  }
}

const normalizeBaseUrl = (value?: string) => (value ?? "").trim().replace(/\/$/, "");

const deriveApiBaseUrl = (): string => {
  if (typeof window === "undefined") return "";
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "";
  // app.aja2.pt → api.aja2.pt
  if (host.startsWith("app.")) {
    return `${window.location.protocol}//api.${host.slice(4)}`;
  }
  return "";
};

export const getApiBaseUrl = (): string => {
  const runtimeValue =
    typeof window !== "undefined" ? window.__APP_CONFIG__?.API_BASE_URL : undefined;
  const envValue = process.env.REACT_APP_API_BASE_URL;
  return normalizeBaseUrl(runtimeValue || envValue || deriveApiBaseUrl());
};

export {};
